import { ButtonRoundStyle, Form, RHFTextField } from '@/components'
import { TitleLoginForm } from '@/features/auth/components'
import { Box, Button, Grid, Stack, styled, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useForm } from 'react-hook-form'

type Props = {}

export const UpdateProfileForm = (props: Props) => {
  const t = useTranslations('UserProfile')
  const method = useForm()
  return (
    <Stack spacing={2}>
      <Box>
        <TitleLoginForm title={t('Cập nhật tài khoản của bạn')} />
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: {
              xs: '0.75rem',
              md: '0.875rem',
            },
            fontWeight: 300,
          }}
        >
          {t.rich(
            'Để lại thông tin của bạn để chúng tôi biết thêm về bạn và bạn sẽ luôn luôn nhận được những khuyến mãi mới nhất đến từ chúng tôi',
            {
              bold: (chunks) => <span style={{ fontWeight: 'bold' }}>{chunks}</span>,
            }
          )}
        </Typography>
      </Box>
      <Form methods={method} onSubmit={() => {}}>
        <Grid spacing={1} container>
          <Grid size={12}>
            <RHFTextField
              name="firstName"
              label={t('Họ và tên của bạn')}
              placeholder={t('Nhập họ và tên của bạn')}
              required
            />
          </Grid>
          {/* Email field - commented out as not needed for password update */}
          {/* <Grid size={6}>
            <RHFTextField name="email" label={'Email'} placeholder={t('Nhập email của bạn')} required />
          </Grid> */}

          {/* Phone number field - commented out as not needed for password update */}
          {/* <Grid size={6}>
            <RHFTextField
              name="phoneNumber"
              label={t('Số điện thoại')}
              placeholder={t('Nhập số điện thoại')}
              required
            />
          </Grid> */}

          {/* Address field - commented out as not needed for password update */}
          {/* <Grid size={12}>
            <RHFTextField
              name="address"
              label={t('Địa chỉ')}
              placeholder={t('Nhập địa chỉ của bạn')}
              required
            />
          </Grid> */}
        </Grid>
        <ButtonRoundStyle variant="contained" type="submit" sx={{ mt: 2 }}>
          {t('Cập nhật thông tin')}
        </ButtonRoundStyle>
      </Form>
    </Stack>
  )
}
